// extracted by mini-css-extract-plugin
export var width100 = "y_w d_w";
export var design3Pos = "y_t1 d_0";